import React from 'react';
import Select, { components } from 'react-select';

import OnHoverTooltip from './OnHoverTooltip';

import '../../../styles/components/officeFilterCell.scss';

const CustomSelect = ({ options, columnName, onSelectedChange, selected }) => {
    return (
        <th className='office-filter'>
            {selected && selected.length > 1 ? (
                <OnHoverTooltip
                    labelClassNames='office-filter-icon d-flex justify-content-center align-items-center bg-white'
                    dataFor='office-tooltip'
                    tooltipType='dark'
                    tooltipPlace='top'>

                    <span className='c-steelblue'>+{(selected.length - 1)}</span>
                    <span>Valda filter: {selected.map((option) => option.value + ' ')}</span>

                </OnHoverTooltip>
            ) : null}

            <Select
                hideSelectedOptions={false}
                placeholder='Filter...'
                value={selected}
                components={{ MultiValueContainer, Option }}
                isMulti
                classNamePrefix='select-container'
                options={options}
                onChange={(e) => {
                    onSelectedChange(e);
                }}
            />
        </th>
    );
};

export default CustomSelect;

const Option = (props) => (
    <components.Option {...props}>
        <label className='checkbox-item margin-none padding-none padding-left-40px'>
            <input type='checkbox' checked={props.isSelected} onChange={() => null} />
            <span className='checkbox-item-checkmark margin-left-none'></span>
            {props.label}
        </label>
    </components.Option>
);

const MultiValueContainer = (props) => {
    const selectedOptions = props.selectProps.value;

    const lastSelected = selectedOptions[selectedOptions.length - 1];

    const selectedOption = props.data;

    if (lastSelected.value === selectedOption.value) {
        return <components.MultiValueContainer {...props} />;
    }

    return (
        <div className='hidden-select-option'>
            <components.MultiValueContainer {...props} />;
        </div>
    );
};
